















import {
  Component,
  Vue,
  Emit,
  PropSync,
  Watch,
  Prop
} from "vue-property-decorator";
import { namespace } from "vuex-class";

@Component
export default class TireDetailDialog extends Vue {
  @PropSync("visible", { type: Boolean, default: false })
  dialogVisible: boolean;
  @Prop({ type: Array, default: () => [] }) dataList;

  @Watch("visible")
  watchVisibleFn(val) {
    if (val) {
      // 初始化弹窗数据
    } else {
      // let $form: any = this.$refs.form;
      // $form && $form.resetFields();
    }
  }
  created() {
    // 获取导出项配置
  }
}
